module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "pt01"
    }
  }, [_c('h1', {
    staticClass: "part"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Contents#pt01a"
    }
  }, [_vm._v("Part I")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("“And that I walk thus proudly crowned withal"), _c('br'), _vm._v("Is that ‘tis my distinction; if I fall,"), _c('br'), _vm._v("I shall not weep out of the vital day,"), _c('br'), _vm._v("To-morrow dust, nor wear a dull decay”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Percy Bysshe Shelley,"), _c('br'), _vm._v("“And That I Walk Thus"), _c('br'), _vm._v("Proudly Crowned Withal”")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("“When I was small and five"), _c('br'), _vm._v("I found a pencil sharpener alive!"), _c('br'), _vm._v("He lay in lonely grasses"), _c('br'), _vm._v("Looking for work."), _c('br'), _vm._v("I bought a pencil for him."), _c('br'), _vm._v("He ate and ate until all that was"), _c('br'), _vm._v("Left was a pile of wood dust."), _c('br'), _vm._v("It was the happiest pencil sharpener"), _c('br'), _vm._v("I ever had”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Spike Milligan, “2B or not 2B”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-157a6ad0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062378576_B1_Part_1.vue
// module id = 75
// module chunks = 0